module.exports = __webpack_public_path__ + "img/sony-logo.0c8f22ce.jpg";